import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAppConnection,
  patchAppConnection,
} from "../../slices/accessManagerSlice";
import EditableTable from "../../components/EditableTable";
import Pagination from "../../components/Pagination";
import Loader from "../../components/Loader";
import Modal from "../../components/Modal";
import ChangeLog from "../../components/ChangeLog";

const AccessConnection = () => {
  const dispatch = useDispatch();
  const { appConnection, status, error } = useSelector(
    (state) => state.accessManager
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});

  const itemsPerPage = 5;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(appConnection?.result)
    ? appConnection?.result.slice(indexOfFirstItem, indexOfLastItem)
    : [];
  const totalPages = Array.isArray(appConnection?.result)
    ? Math.ceil(appConnection?.result?.length / itemsPerPage)
    : 0;
  const headers =
    appConnection?.result?.length > 0
      ? Object.keys(appConnection?.result[0]).filter((key) => key !== "id")
      : [];
  const editableFields = ["title"]; // Define editable fields
  const [currentLog, setCurrentLog] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    dispatch(fetchAppConnection());
  }, [dispatch]);

  if (status === "loading") {
    return (
      <div className="pt-12">
        <Loader />
      </div>
    );
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = appConnection?.result.find((user) => user.id === rowId);
    setEditedData(rowData);
  };

  const handleSave = async () => {
    const { id, ...editableData } = editedData;
    const updatedData = { id, ...editableData };
    console.log(updatedData);
    const resp = await dispatch(patchAppConnection(updatedData));
    if (!resp.error) {
      setEditRowId(null);
      dispatch(fetchAppConnection());
    }
  };

  const handleCancel = () => {
    setEditRowId(null);
    setEditedData({});
  };

  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleLog = (id) => {
    const logData = appConnection?.Change_Log.filter((f) => f.id === id)[0]
      ?.oldTrack;
    setCurrentLog(logData);
    openModal();
  };

  return (
    <div className="w-full flex items-center flex-col">
      <div className="max-w-full">
        <EditableTable
          headers={headers}
          rows={currentItems}
          editRowId={editRowId}
          editedData={editedData}
          handleEdit={handleEdit}
          handleSave={handleSave}
          handleCancel={handleCancel}
          handleChange={handleChange}
          handleLog={handleLog}
          editableFields={editableFields} // Pass editable fields
        />
      </div>
      
      <div className="flex mt-4 items-center justify-between w-11/12">
        <Pagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
        />
      </div>

      <Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog} />}
      />

    </div>
  );
};

export default AccessConnection;
